module.exports = __webpack_public_path__ + "img/maersk-logo.c7fac953.svg";